// CANONICAL COPY (GH #7115). src/constants/obligations/obl-data-deletion.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-data-deletion',
  title: 'Verify secure data deletion procedures',
  description:
    'Confirm that information stored in information systems, devices or other storage media is deleted when no longer required, using secure deletion methods appropriate to the sensitivity of the data. Review retention schedules, purge jobs and secure-wipe/destruction records.',
  category: 'compliance',
  scfIds: ['SCF-DAT-003'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Data deletion / retention policy is published' },
    { type: 'document-within-sla', description: 'Policy review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
